import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';
import SelectDataset from '../common/SelectDataset';
import HeatMap from '../common/charts/HeatMap';
import Methodology from '../common/Methodology';

const CountryOverview = props => {

	const [dataset, setDataset] = useState('');

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22008 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	const handleDatasetChange = (dataset) => 
	{
		setDataset(dataset);
	}

	return (
		<div className="social-dialogue country-overview">
			<AdviceSection literals={ props.literals } section={["osh-steering","development-eu-countries"]} methodologyData={{section: 'osh-steering', subsection: 'Developments in EU countries', indicator: 354}} />

			<section className="container">
				<form className="row block--filter--wrapper">
					
					{/* DATASET FILTER */}
					<SelectDataset chart= { '20090' } indicator={ ['554', '555', '557', '556'] } esener= { 'true' } handleDatasetChange={ handleDatasetChange } />
					<p className="btn--wrapper text-center">
						<Link to='/osh-steering/social-dialogue/development-eu-countries' className="btn-default btn-main-color text-center ">{ props.literals.L20029 }</Link>
					</p>
				</form>
				<h3>{ props.literals.L20028 }</h3>
				<p>{ ReactHtmlParser( props.literals.L20031 ) }</p>

				<HeatMap
					literals = { props.literals }
					title = { props.literals.L20028 }
					chart = { '20090' }
					dataset = { dataset }
					xAxisCategories = { [ props.literals.L20659, props.literals.L20660, props.literals.L20661, props.literals.L20662 ] }
				/>
			</section>

			<Methodology literals={ props.literals } section={'Developments in EU countries'} />
		</div>            
	)
}
CountryOverview.displayName = 'CountryOverview';
export default CountryOverview;